import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { IEventLog } from '../../../model/event-logs';
import { ILocationContext } from '../../../model/location-context';
import EventLogsActions from './store/event-logs.action-types';
import { EventLogsState } from './store/event-logs.reducers';
import { eventLogsSelector } from './store/event-logs.selectors';

@Injectable({
    providedIn: 'root'
})
export class EventLogsService {
    constructor(private readonly store: Store<EventLogsState>) {}

    requestEventLogs(locationContext: ILocationContext) {
        this.store.dispatch(EventLogsActions.requestEventLogs({ locationContext }));
    }

    loadEventLogs(eventLogs: IEventLog[]) {
        this.store.dispatch(EventLogsActions.loadEventLogs({ eventLogs }));
    }

    getEventLogs(): Observable<IEventLog[]> {
        return this.store.select(eventLogsSelector);
    }
}
